import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '40px' }}>
      <h1>Privacy Policy</h1>
      <p><strong>Last updated:</strong> August 3, 2025</p>

      <p>
        ChicLogic.io (“we,” “our,” or “us”) operates the ChicLogic.io application and related services. 
        This Privacy Policy describes how we collect, use, and protect your information when you use our platform.
      </p>

      <h2>1. Information We Collect</h2>
      <ul>
        <li><strong>Personal Information:</strong> Name, email address, and social media account links.</li>
        <li><strong>Content Inputs:</strong> Text you submit (e.g., post captions) for hashtag or content suggestions.</li>
        <li><strong>Usage Data:</strong> App activity, feature usage, timestamps, and technical metadata.</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>Provide and personalize our services.</li>
        <li>Generate content recommendations using AI.</li>
        <li>Improve app performance and product features.</li>
        <li>Respond to user support inquiries.</li>
      </ul>

      <h2>3. Use of Artificial Intelligence and Automation</h2>
      <p>
        ChicLogic.io uses automated systems, including <strong>OpenAI’s large language models</strong>, 
        to generate hashtag recommendations, caption feedback, and related content suggestions.
      </p>
      <ul>
        <li>Your submitted content may be processed by OpenAI’s API to provide insights.</li>
        <li>AI responses are generated automatically and are not reviewed by a human before delivery.</li>
        <li>AI-generated results are for guidance purposes only and should not be treated as fact or professional advice.</li>
      </ul>
      <p><strong>We do not</strong> use AI for profiling, eligibility decisions, or any high-risk decision-making.</p>

      <h2>4. Third-Party Services</h2>
      <p>We rely on third-party APIs and services, including:</p>
      <ul>
        <li><strong>OpenAI</strong> (for language model processing)</li>
        <li><strong>Meta APIs</strong> (for Instagram data such as hashtag view counts)</li>
      </ul>
      <p>
        These services may temporarily process your data as part of their functionality, 
        but ChicLogic.io does not share or sell your data to them.
      </p>
      <p>See their privacy policies:</p>
      <ul>
        <li><a href="https://openai.com/privacy" target="_blank" rel="noopener noreferrer">OpenAI’s Privacy Policy</a></li>
        <li><a href="https://www.facebook.com/policy.php" target="_blank" rel="noopener noreferrer">Meta’s Privacy Policy</a></li>
      </ul>

      <h2>5. Data Retention</h2>
      <p>
        We retain your information for as long as your account is active or as needed to provide our services. 
        You may request deletion of your data at any time by contacting us.
      </p>

      <h2>6. Data Security</h2>
      <p>
        We implement appropriate administrative, technical, and physical safeguards to protect your information. 
        This includes data encryption, secure authentication, and strict access controls.
      </p>

      <h2>7. Your Rights</h2>
      <p>You may request:</p>
      <ul>
        <li>Access to your personal data</li>
        <li>Correction of inaccurate information</li>
        <li>Deletion of your data</li>
        <li>Limitations on processing (where applicable by law)</li>
      </ul>
      <p>
        We currently serve users in the U.S., but if you are a resident of the EU or another region with data protection laws, 
        we will honor your rights under the applicable law.
      </p>

      <h2>8. Children’s Privacy</h2>
      <p>
        Our services are not directed to children under the age of 13. 
        We do not knowingly collect data from anyone under this age.
      </p>

      <h2>9. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy periodically. When we do, we’ll revise the “Last updated” date 
        and notify you if significant changes are made.
      </p>

      <h2>10. Contact Us</h2>
      <p>If you have any questions or concerns about this policy or your data, please contact us at:</p>
      <p>
        <strong>Email:</strong>{' '}
        <a href="mailto:connect@ChicLogic.io">connect@ChicLogic.io</a>
      </p>
    </div>
  );
};

export default PrivacyPolicy;
